import { useContext, useEffect, useRef, useState } from "react";
import { ThemeContext } from "@emotion/react";
import { Backdrop, Box, Button, Checkbox, Chip, Fade, FormControlLabel, Grid, Modal, TextField, Typography } from "@mui/material";
import swal from "sweetalert2";
import { VerifyTag } from "../../../../../hooks/verifyTag";
import { Delete } from "@mui/icons-material";
import { Spliteo } from "../../../../../hooks/spliteo";
import { TiposSplitEnum } from "../../../../../@enums/tipo_split.enum";
import { useSelector } from "react-redux";
import { useLoading } from "../../../../../components/Loading/useLoading";
import { TicketLocal } from "../../../../../hooks/sendPrint";
import { ModalConfirmacionTag } from "./modalConfirmacionTag";

export const ModalSplit = ({ open, setOpen, almacen }) => {

  const style = {
    position: "absolute",
    top: "35%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: 500,
    maxWidth: 800,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 3,
    display: "flex",
    justifyContent: "center",
  };
  const { setAppLoading } = useLoading();
  const formData = useRef(null);
  const inputRefSplit = useRef(null);
  const printerId = useSelector((state) => state.app.printerId);
  const theme = useContext(ThemeContext);
  const { verifyTagMutation } = VerifyTag();
  const { spliteoMutation } = Spliteo();
  const { ticketLocalMutation } = TicketLocal();
  const [paquetes, setPaquetes] = useState([]);
  const [paqGruop, setPaqGroup] = useState([]);
  const [isMaster, setIsMaster] = useState(false);
  const [returnTags, setReturnTags] = useState(true);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [dataReprint, setDataReprint] = useState([]);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (inputRefSplit.current) {
          inputRefSplit.current.focus();
        }
      }, 200); // Esperar un corto tiempo para asegurarse de que el modal esté completamente renderizado
    } else {
      setReturnTags(true);
    }
  }, [open]);

  const handleClose = () => {
    setPaquetes([]);
    setPaqGroup([]);
    setDataReprint([]);
    setOpenConfirm(false);
    setOpen(false);
    setIsMaster(false);
  };

  const handleEnterPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setAppLoading(true)
      if (paquetes.some((item) => item?.tag === event.target.value)) {
        setAppLoading(false)
        swal.fire({
          position: "center",
          icon: "warning",
          title: "El contenedor ya ha sido agregado",
          width: 600,
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            container: "cont_alt",
          },
        });
      } else {
        let body = {
          etiq_codigo: event.target.value
        };
        verifyTagMutation({ almacen: almacen, data: body }, {
          onSuccess: (data) => {
            setAppLoading(false)
            if (data.success !== false && data.data?.length > 0) {
              if (paquetes.length > 0 && paquetes[0].parte !== data.data[0].parte) {
                swal.fire({
                  position: "center",
                  icon: "error",
                  title:
                    "El contenedor no existe o no cumple con las condiciones necesarias",
                  width: 600,
                  showConfirmButton: false,
                  timer: 1500,
                  customClass: {
                    container: "cont_alt",
                  },
                });
              } else {
                setPaquetes([...paquetes, ...data.data]);
                const agrupado = {};

                data?.data.forEach(item => {
                  const tagId = item.tag_id;

                  if (agrupado[tagId]) {
                    // Si ya existe este tag_id, sumar la cantidad
                    agrupado[tagId].cantidad += item.cantidad;
                  } else {
                    // Si no existe, crear nuevo objeto
                    agrupado[tagId] = {
                      cantidad: item.cantidad,
                      tag: item.tag,
                      tag_id: item.tag_id,
                      delete: false
                    };
                  }
                });

                let new_agrupado = Object.values(agrupado);
                setPaqGroup([...paqGruop, ...new_agrupado])

                if (data.data.some(obj => obj.master === true)) {
                  setIsMaster(true)
                }
                formData.current.etiqueta.value = "";
              }
            } else {
              swal.fire({
                position: "center",
                icon: "error",
                title:
                  "El contenedor no existe o no cumple con las condiciones necesarias",
                width: 600,
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  container: "cont_alt",
                },
              });
            }
          },
          onError: (error) => {
            console.log(error);
            setAppLoading(false)
            swal.fire({
              position: "center",
              icon: "error",
              title:
                "El contenedor no existe o no cumple con las condiciones necesarias",
              width: 600,
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                container: "cont_alt",
              },
            });
          },
        });
      }
      inputRefSplit.current.focus();
    }
  };

  const deleteItem = (index) => {
    let paq = paqGruop;
    if (isMaster) {
      paq[index].delete = true;
    } else {
      paq.splice(index, 1);
    }

    setPaqGroup([...paq]);
  }

  const do_split = (params) => {
    spliteoMutation(params, {
      onSuccess: async (data) => { // <-- Hacemos onSuccess async
        try {
          for (let print of data?.data) {
            setDataReprint(data?.data);
            await new Promise((resolve, reject) => {
              ticketLocalMutation(print, {
                onSuccess: (response) => {
                  resolve(); // Avanza solo cuando termina esta petición
                },
                onError: (error) => {
                  console.log(error);
                  reject(error); // Detiene el proceso si hay error
                }
              });
            });
          }
        } catch (error) {
          console.error("Error en el proceso de impresión:", error);
        }

        // data?.data?.length > 0 ? setOpenConfirm(true) : handleClose();
        handleClose();
        setAppLoading(false);
      },
      onError: (error) => {
        console.log(error);
        handleClose();
        setAppLoading(false);
      }
    });
  }

  const send_split = () => {
    setAppLoading(true);
    if (paquetes.length > 0) {

      let data = []

      if (isMaster) {
        const deleteMap = new Map(
          paqGruop.map(item => [item.tag_id, item.delete])
        );

        // Actualizar paquetes con el valor de delete desde paqGruop
        data = paquetes.map(item => {
          if (deleteMap.has(item.tag_id)) {
            return { ...item, delete: deleteMap.get(item.tag_id) };
          }
          return item;
        });
      } else {
        const tagIdsPermitidos = new Set(
          paqGruop
            .filter(item => item.delete === false)
            .map(item => item.tag_id)  // <-- Agrega esto
        );
        data = paquetes.filter(item => tagIdsPermitidos.has(item.tag_id));
      }

      let params = {
        tipo: isMaster ?
          TiposSplitEnum.EDICION : TiposSplitEnum.CREACION,
        data: {
          data,
          printerId: printerId,
          returnWasteTags: isMaster && returnTags
        }
      }
      do_split(params)
    } else {
      setAppLoading(false);
    }
  }

  const deshacer_split = () => {
    swal.fire({
      title: "¿Esta seguro de deshacer esta master?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Deshacer",
      customClass: {
        container: "cont_alt",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAppLoading(true);

        const tagIdsPermitidos = new Set(
          paqGruop.map(item => item.tag_id)  // <-- Agrega esto
        );
        const data_del = paquetes.filter(item => tagIdsPermitidos.has(item.tag_id));
        let paq = data_del;
        paq.map(objeto => objeto.delete = true);
        let params = {
          tipo: TiposSplitEnum.EDICION,
          data: {
            data: paq,
            printerId: printerId
          }
        }
        do_split(params)
      }
    });
  }

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="modal_carga">
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sx={{ p: 0, mb: 1, pr: 1 }}
                className="center_item"
              >
                <Typography
                  id="transition-modal-title"
                  variant="h6"
                  component="h2"
                >
                  Contenedores Masters
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={4}
                xl={4}
                sx={{
                  p: 1,
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  flexDirection: "column",
                }}
              >
                <form ref={formData} id="form_dom" style={{ width: "100%" }}>
                  <TextField
                    id="etiqueta"
                    size="small"
                    label="Etiqueta"
                    fullWidth
                    inputRef={inputRefSplit}
                    onKeyDown={handleEnterPress}
                    sx={{ color: theme.palette.primary.input, width: "100%", mb: 1.5 }}
                  />
                  {
                    isMaster &&
                    <FormControlLabel control={<Checkbox checked={returnTags} onChange={(e) => setReturnTags(e.target.checked)} />} label="Retornar a linea" />
                  }
                  <Button
                    variant="contained"
                    className="btn_system"
                    sx={{ fontSize: 12, height: 35, }}
                    disableElevation
                    disabled={paquetes.length === 0}
                    onClick={send_split}
                  >
                    Contenedor Lleno
                  </Button>
                  {
                    isMaster &&
                    <Button
                      variant="contained"
                      className="btn_system"
                      sx={{ fontSize: 12, height: 35, mt: 2.5 }}
                      disableElevation
                      disabled={paquetes.length === 0}
                      onClick={deshacer_split}
                    >
                      Deshacer master
                    </Button>
                  }
                </form>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={8}
                xl={8}
                sx={{
                  p: 1,
                  gap: 2,
                  display: "flex",
                  alignItems: "flex-start",
                  border: "1px solid #D9D9D9",
                  borderRadius: 5,
                }}
              >
                <Grid
                  container
                  spacing={0}
                  sx={{
                    p: 1,
                    textAlign: "start",
                    display: "flex",
                    alignItems: "center",
                    overflowY: 'scroll',
                    maxHeight: '400px'
                  }}
                >
                  {paqGruop?.map((paq, index) => (
                    <>
                      {
                        !paq?.delete &&
                        <Grid
                          item
                          xs={6}
                          sx={{
                            p: 1,
                            textAlign: "start",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Chip
                            label={
                              <div
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  style={{
                                    marginRight: 7,
                                    fontSize: 12,
                                    fontWeight: 400,
                                    color: "black",
                                  }}
                                >
                                  {paq?.cantidad}
                                </span>
                                <span
                                  style={{
                                    marginLeft: 7,
                                    border: "1px solid #575E3B",
                                    borderRadius: 4,
                                    fontSize: 11,
                                    padding: 3,
                                    color: "#575E3B",
                                  }}
                                >
                                  {paq?.tag}
                                </span>
                              </div>
                            }
                            variant="outlined"
                            deleteIcon={
                              <Delete sx={{ marginLeft: "5px !important", width: 18 }} />
                            }
                            onDelete={() => deleteItem(index)}
                            sx={{
                              height: 40,
                              borderRadius: 2,
                              display: "flex",
                              justifyContent: "center",
                              width: "100%",
                              backgroundColor: "transparent",
                            }}
                          />
                        </Grid>
                      }
                    </>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
      {/* <ModalConfirmacionTag key="modal_confirm" open={openConfirm} setOpen={setOpenConfirm} dataReprint={dataReprint} onClose={handleClose} /> */}
    </>
  )
}